import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../../axios/index";
import { Link } from "react-router-dom";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// components
import DashboardMainFiles from "./DashboardMainFiles";
import DashboardMainCharts from "./DashboardMainCharts";
import DashboardMainReminders from "./DashboardMainReminders";

// Styles
import styles from "./DashboardMain.module.css";
import Dstyles from "../DashboardFileManagement/DashboardFileManagement.module.css";

// Re Useable Components
import DashboardSideMenu from "../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../DashboardReuseAbleComponents/DashboardHeader";
import ShowProfileModal from "../DashboardFileManagement/CardDetail/ShowProfileModal";

// Images
import arrowIcon from "./../../../assets/img/DashboardICons/ArrowRounded.svg";
import settingIcon from "./../../../assets/img/DashboardICons/settingIcon.svg";
import ConsultantCommissionCalculateModal from "../ConsultantCommissionCalculateModal/ConsultantCommissionCalculate";

const DashboardMain = () => {
  const { userToken } = useContext(UserContext);
  const [modalShow, setModalShow] = useState(false);
  const [commissionModal, setCommissionModal] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardFileData, setDashboardFileData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isShowSidebar, setIsShowSidebar] = useState(true);

  useMemo(() => dashboardData, [dashboardData]);

  useEffect(() => {
    sessionStorage.removeItem("searchData");
    sessionStorage.removeItem("pageData");
    sessionStorage.removeItem("categories");
    sessionStorage.removeItem("subCategory");
    sessionStorage.removeItem("mainCategory");
    sessionStorage.removeItem("dealType");
    sessionStorage.removeItem("filters");
  }, []);

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)
      const getData = await axios.get("Admin/AdminPageData", {
        headers: { authorization: "Bearer " + userToken },
      });

      const getFilesData = await axios.get("Estate?OrderBy=2&Take=7", {
        headers: { authorization: "Bearer " + userToken },
      });

      const dashboardData = getData.data.data;
      // console.log(dashboardData)
      setDashboardData(dashboardData);
      setDashboardFileData(getFilesData.data.data.data);

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken]);

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      <ConsultantCommissionCalculateModal show={commissionModal} onHide={() => setCommissionModal(false)} />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className={isShowSidebar ? "col-md-9" : "col-md-12"}>
              <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} onClick={() => setModalShow(true)} />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    {/*<img className='ms-2' src={arrowIcon} alt="icon" />*/}
                    <div className={styles.text1}>داشبورد</div>
                  </div>

                  <div className="d-flex align-items-center gap-4" style={{ gap: "15px" }}>
                    <div onClick={() => setCommissionModal(true)} className="d-flex align-items-center justify-content-end flex-wrap mt-2 mb-2 pointer">
                      <div className={styles.setting_text}>محاسبه کمیسیون آنلاین</div>
                    </div>

                    <Link to={`/settings`} className="d-flex align-items-center justify-content-end flex-wrap mt-2 mb-2">
                      <img className="ms-2 ps-1" src={settingIcon} alt="setting-icon" />
                      <div className={styles.setting_text}>تنظیمات سایت</div>
                    </Link>
                  </div>
                </div>

                {/* Total Dashboard Main Info */}

                <DashboardMainFiles
                  dashboardData={dashboardData?.estateFileStatus}
                  personnelCount={dashboardData?.personnelCount}
                  userCount={dashboardData?.userCount}
                  dashboardFileData={dashboardFileData}
                />
                <DashboardMainCharts dashboardData={dashboardData?.estateFileChart} />
                <DashboardMainReminders dashboardData={dashboardData?.newNotes} />
              </div>
            </div>
            <div
              className={isShowSidebar ? "col-md-3" : "hidden"}
              style={{
                display: isShowSidebar ? "block" : "none",
              }}>
              {/* sideMenu starts */}
              <DashboardSideMenu dashboarOn setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardMain;
